/* Ascension Foods — motion engine
   Vanilla reveal system ported from Physique Ascension Club.
   IntersectionObserver + manual sweep fallback, word splitting,
   magnetic buttons, optional Lenis smooth scroll. No GSAP. */

(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tick = 0;

  /* ---- Split [data-split] text into per-word spans ---- */
  function splitText() {
    document.querySelectorAll('[data-split]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';
      var out = document.createElement('span');
      (function walk(node, dest) {
        Array.prototype.forEach.call(node.childNodes, function (n) {
          if (n.nodeType === 3) {
            (n.textContent || '').split(/(\s+)/).forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) {
                dest.appendChild(document.createTextNode(' '));
              } else {
                var wrap = document.createElement('span');
                wrap.className = 'split-word';
                var inner = document.createElement('span');
                inner.className = 'w';
                inner.textContent = p;
                wrap.appendChild(inner);
                dest.appendChild(wrap);
              }
            });
          } else if (n.nodeType === 1) {
            var clone = n.cloneNode(false);
            walk(n, clone);
            dest.appendChild(clone);
          }
        });
      })(el, out);
      el.innerHTML = '';
      Array.prototype.slice.call(out.childNodes).forEach(function (c) { el.appendChild(c); });
      el.querySelectorAll('.split-word .w').forEach(function (w, i) {
        w.style.transitionDelay = (i * 0.055) + 's';
      });
    });
  }

  /* ---- Reveal in view ---- */
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0;
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  function observeReveals() {
    document.querySelectorAll('.fade-up, .stagger, .mask-reveal, [data-split]').forEach(function (el) {
      if (el.dataset.observed) return;
      el.dataset.observed = '1';
      if (reduce || !io || inViewport(el)) el.classList.add('in');
      else io.observe(el);
    });
  }

  function sweep() {
    document.querySelectorAll(
      '.fade-up:not(.in), .stagger:not(.in), .mask-reveal:not(.in), [data-split]:not(.in)'
    ).forEach(function (el) { if (inViewport(el)) el.classList.add('in'); });
  }

  /* ---- Magnetic buttons ---- */
  function magnetic() {
    if (reduce) return;
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
      if (el.dataset.magBound) return;
      el.dataset.magBound = '1';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + (dx * 0.18) + 'px,' + (dy * 0.3) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- Lenis smooth scroll (optional) ---- */
  function initLenis() {
    if (reduce || !window.Lenis) return;
    try {
      var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true });
      (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })();
      lenis.on('scroll', function () { if ((tick++ & 3) === 0) sweep(); });
      window.__afLenis = lenis;
    } catch (e) {}
  }

  function boot() {
    splitText();
    observeReveals();
    magnetic();
    initLenis();
    window.addEventListener('scroll', function () { if ((tick++ & 3) === 0) sweep(); }, { passive: true });
    setTimeout(function () { observeReveals(); sweep(); }, 60);
    setTimeout(function () { observeReveals(); sweep(); }, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  /* Re-sweep when the preloader releases the page */
  document.addEventListener('af:loaded', function () { observeReveals(); sweep(); });
})();
